import { render, staticRenderFns } from "./NyranSurvivors.vue?vue&type=template&id=2b318e18&"
import script from "./NyranSurvivors.vue?vue&type=script&lang=js&"
export * from "./NyranSurvivors.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports